export const GET_DRIVER_HISTORY_PENDING = "GET_DRIVER_HISTORY_PENDING"
export const GET_DRIVER_HISTORY_SUCCESS = "GET_DRIVER_HISTORY_SUCCESS"
export const GET_DRIVER_HISTORY_FAILURE = "GET_DRIVER_HISTORY_FAILURE"

export const ADD_DRIVER_HISTORY_PENDING = "ADD_DRIVER_HISTORY_PENDING"
export const ADD_DRIVER_HISTORY_SUCCESS = "ADD_DRIVER_HISTORY_SUCCESS"
export const ADD_DRIVER_HISTORY_FAILURE = "ADD_DRIVER_HISTORY_FAILURE"

export const EDIT_DRIVER_HISTORY_PENDING = "EDIT_DRIVER_HISTORY_PENDING"
export const EDIT_DRIVER_HISTORY_SUCCESS = "EDIT_DRIVER_HISTORY_SUCCESS"
export const EDIT_DRIVER_HISTORY_FAILURE = "EDIT_DRIVER_HISTORY_FAILURE"

export const DELETE_DRIVER_HISTORY_PENDING = "DELETE_DRIVER_HISTORY_PENDING"
export const DELETE_DRIVER_HISTORY_SUCCESS = "DELETE_DRIVER_HISTORY_SUCCESS"
export const DELETE_DRIVER_HISTORY_FAILURE = "DELETE_DRIVER_HISTORY_FAILURE"

export const DOWNLOAD_DRIVER_HISTORY_PENDING = "DOWNLOAD_DRIVER_HISTORY_PENDING"
export const DOWNLOAD_DRIVER_HISTORY_SUCCESS = "DOWNLOAD_DRIVER_HISTORY_SUCCESS"
export const DOWNLOAD_DRIVER_HISTORY_FAILURE = "DOWNLOAD_DRIVER_HISTORY_FAILURE"